import { InMemoryCache, ErrorPolicy, FetchPolicy } from '@apollo/client';
import _merge from 'lodash/merge';
import createProfileEditUploadedPhotoResolvers, {
  initializeCreateProfileUploadedPhotoState,
} from '@consumer-talent.lib/ApolloLinkState/createProfileEditUploadedPhoto';
import editProfileResolvers, { initializeUpdatedProfileFieldState } from '@consumer-talent.lib/ApolloLinkState/editProfile';
import editUploadedPhotoResolvers, { initializeUploadedPhotoDataState } from '@consumer-talent.lib/ApolloLinkState/editUploadedPhoto';
import loginResolvers, { initializeLoginState } from '@consumer-talent.lib/ApolloLinkState/login';

// use this after instantiating the cache to initialize the cache
// for client-only state
export const INIT_CACHE_STATE = (inMemCache: InMemoryCache): void => {
  initializeCreateProfileUploadedPhotoState(inMemCache);
  initializeUpdatedProfileFieldState(inMemCache);
  initializeUploadedPhotoDataState(inMemCache);
  initializeLoginState(inMemCache);
};

export const RESOLVERS = () =>
  _merge(
    createProfileEditUploadedPhotoResolvers.resolvers,
    editProfileResolvers.resolvers,
    editUploadedPhotoResolvers.resolvers,
    loginResolvers.resolvers
  );

export const DEFAULT_OPTIONS = () => ({
  query: {
    fetchPolicy: 'cache-and-network' as FetchPolicy,
    errorPolicy: 'all' as ErrorPolicy,
  },
  mutate: {
    errorPolicy: 'all' as ErrorPolicy,
  },
});

// spread this into the ApolloClient config
export const BASE_CONFIG = () => ({
  resolvers: RESOLVERS(),
  defaultOptions: DEFAULT_OPTIONS(),
});
